/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 16:08:12
 * @LastEditors: xgx
 * @LastEditTime: 2022-11-21 09:39:34
 */
import req from "@/utils/request";

export const list = (params) => req.post("/site-service/m/site/list", params);